import React, {FC} from 'react';
import styled from 'styled-components';

import {NewPaletteColorsEnum} from '../../../../../../libs/shared/ui/src/styles/colorStyles';
import {fontSizes, fontWeights} from '../../../../../../libs/shared/ui/src/styles/fontStyles';
import {ConversationTeamStatusesEnum} from '../../../../../models/api/conversationCommonTypes';

/*
 * Props.
 */

interface ConversationCardStatusProps {
  status: ConversationTeamStatusesEnum;
}

/*
 * Styles.
 */

interface StyledConvStatusProps {
  $color: NewPaletteColorsEnum;
}

const StyledConvStatus = styled.div<StyledConvStatusProps>`
  grid-area: status;
  justify-self: end;

  display: inline-block;
  padding: 2px 4px;
  color: ${(props) => props.theme.palette[props.$color].shade50};
  background-color: ${(props) => props.theme.palette[props.$color].shade20};
  text-transform: uppercase;
  font-weight: ${fontWeights.semibold};
  font-size: ${fontSizes.veryTiny};
  border-radius: 4px;
  line-height: 15px;
`;

/*
 * Component.
 */

export const ConversationCardStatus: FC<ConversationCardStatusProps> = ({status}) => (
  <StyledConvStatus $color={getStatusColor(status)}>{status}</StyledConvStatus>
);

/*
 * Helpers.
 */

function getStatusColor(status: ConversationTeamStatusesEnum) {
  switch (status) {
    case ConversationTeamStatusesEnum.ARCHIVED:
      return NewPaletteColorsEnum.GREEN;
    default:
      return NewPaletteColorsEnum.RED;
  }
}
